import { FC, useState } from "react";
import Input from "antd/lib/input/Input";
import { Button, Form } from "antd";
import styles from "./styles.module.css";
import { emailValid } from "../../../utils";
import { useAppDispatch, useAppSelector } from "../../../store";
import { SetEmail } from "../../../store/slices/registrationSlice";
import {
  setAccountEmail,
  signupByEmail,
} from "../../../store/actions/registrationAction";
import { tabsNamesKeys } from "../Registration.models";
import { ArrowLeftOutlined } from "@ant-design/icons";

interface IEmailProps {
  setStep: (step: tabsNamesKeys) => void;
}

interface IRegistrationEmailFormValues {
  email: string;
}

const Email: FC<IEmailProps> = ({ setStep }) => {
  const dispatch = useAppDispatch();
  const { _isLoading, _isForeignPhone } = useAppSelector(
    (state) => state.registrationSlice
  );

  const [form] = Form.useForm<IRegistrationEmailFormValues>();

  const [isSubmittable, setIsSubmittable] = useState(false);

  const onValuesChange = (_: any, allValues: IRegistrationEmailFormValues) => {
    const { email } = allValues;
    const isValid = Boolean(email?.length);

    setIsSubmittable(isValid);
  };

  const onFinishHandler = (values: IRegistrationEmailFormValues) => {
    const { email } = values;

    dispatch(SetEmail(email));

    if (_isForeignPhone) {
      dispatch(signupByEmail({ setStep }));
      return;
    }

    dispatch(setAccountEmail({ setStep }));
  };

  return (
    <div className="passport">
      <p className={styles.subtitle}>Введите ваш email</p>
      <Form
        form={form}
        onValuesChange={onValuesChange}
        layout="vertical"
        onFinish={onFinishHandler}
      >
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: "Пожалуйста, введите ваш email",
            },
            {
              pattern: emailValid,
              message: "Неверный формат почты",
            },
          ]}
        >
          <Input
            className={styles.input}
            placeholder="Ваш email"
            type="email"
          />
        </Form.Item>
        <p className={styles.emailHint}>
          Код подтверждения будет отправлен на указанный email. Его необходимо
          будет ввести в следующем окне.
        </p>
        <Form.Item shouldUpdate>
          <Button
            type="primary"
            htmlType="submit"
            className={styles.nextButton}
            disabled={!isSubmittable || _isLoading}
            block
          >
            Получить код
          </Button>
        </Form.Item>
        {!_isForeignPhone && (
          <Form.Item>
            <Button
              type="primary"
              className={styles.skipButton}
              onClick={setStep.bind(null, tabsNamesKeys.password)}
            >
              Пропустить
            </Button>
          </Form.Item>
        )}
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          className={styles.backButton}
          onClick={setStep.bind(null, tabsNamesKeys.phone)}
        >
          Вернуться к вводу номера телефона
        </Button>
      </Form>
    </div>
  );
};

export default Email;
